module.exports = __webpack_public_path__ + "img/DK64865218.2869d4ba.png";